import { render, staticRenderFns } from "./PurchasePlanList.vue?vue&type=template&id=23553ef1&scoped=true"
import script from "./PurchasePlanList.vue?vue&type=script&lang=js"
export * from "./PurchasePlanList.vue?vue&type=script&lang=js"
import style0 from "./PurchasePlanList.vue?vue&type=style&index=0&id=23553ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23553ef1",
  null
  
)

export default component.exports